import React from 'react'
import PropTypes from 'prop-types'
import { SCHEDULED } from 'domains/merchant-inbound/constants'
import StatusBadge from 'components/atoms/status-badge'

const propTypes = {
  scheduled: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.string.isRequired
  ])
}

/**
 * It maps `scheduled` to certain style and pass to `StatusBadge`.
 * @param {string} scheduled Merchant Inbound scheduled status. available values
 * - `true`
 * - `false`
 */
const MerchantInboundScheduleBadge = ({ scheduled }) => {

  const colorMap = {
    [SCHEDULED.YES] : 'success',
    [SCHEDULED.NO]  : 'warning'
  }

  const labelMap = {
    [SCHEDULED.YES] : 'Scheduled',
    [SCHEDULED.NO]  : 'Unscheduled'
  }

  const color = colorMap[scheduled] || 'default'
  const label = labelMap[scheduled] || ''

  return <StatusBadge color={ color } label={ label } />
}

MerchantInboundScheduleBadge.propTypes = propTypes

export default MerchantInboundScheduleBadge